import { FaExclamationCircle } from 'react-icons/fa';
import flower from '@images/hotpng.com.png';
import { executeLink } from '@utils';
import { ConfigKeys } from '@enums';

export const ErrorMessage = (props) => {
  return (
    <div className="common-error-message">
      {props.children || (
        <>
          <p className="error-message-container">
            <FaExclamationCircle className="error-icon" />
            <br /> Something went wrong.
            <br />
            Don't worry text to the developer
            <a className="error-link" href={executeLink(ConfigKeys.DEVELOPER_CONTACT_MAIL, true)}>
              Jump
            </a>
            <br />
            Or hit on the flower and relax :)
            <a className="error-link" href="https://mg.ventionteams.com">
              <img className="error-image" src={flower} alt="цветочек" />
            </a>
          </p>
        </>
      )}
    </div>
  );
};
